const scheduleFrame = (callback: () => void) => {
    if (typeof requestAnimationFrame === "function") requestAnimationFrame(callback)
    else setTimeout(callback, 16)
}

export const createFrameNotifier = () => {
    const listeners = new Set<() => void>()
    let scheduled = false

    const notifyListeners = () => {
        scheduled = false
        listeners.forEach((listener) => listener())
    }

    const notify = () => {
        if (scheduled) return
        scheduled = true
        scheduleFrame(notifyListeners)
    }

    const subscribe = (listener: () => void) => {
        listeners.add(listener)
        return () => {
            listeners.delete(listener)
        }
    }

    return { notify, subscribe }
}
